<script lang="ts" setup>
import ky from "ky";
import {ref} from "vue";
import {useModalsStore} from "@/stores/modals";

const modalStore = useModalsStore()

export type TRequisite = {
  id: number,
  title: string,
  organizationFullName: string,
  inn: number,
  entryTitle?: string,
  'phone[number]'?: string,
  phone: string
}

type TProps = {
  requisite: TRequisite
}

const props = defineProps<TProps>()
const isLoading = ref(false);

const remove = async () => {
  try {
    isLoading.value = true

    const response = await ky(`/requisites/${props.requisite.id}`, {
      method: 'delete',
    })

    const detail = await response.json()

    window.dispatchEvent(new CustomEvent('requisitesUpdate', {
      detail
    }))
  } catch (_) {
    // empty
  } finally {
    isLoading.value = false
  }
}

const edit = () => {
  modalStore.setRequisite(props.requisite)
  modalStore.showRequisitesModal()
}
</script>

<template>
  <div class="flex flex-col p-5 border justify-between hover:bg-[hsl(var(--roke-fill-grey))] min-h-[14.313rem]">
    <div class="flex justify-between"><span>{{ props.requisite.title }}</span>
      <div class="flex items-center gap-[1.055rem]">
        <button :class="{'opacity-70': isLoading}" :disabled="isLoading" @click="edit">
          <svg class="cursor-pointer transition-colors hover:text-[hsl(var(--roke-text-blue))]" fill="none" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.6278 1.69818C21.9573 1.36868 21.9573 0.83444 21.6278 0.504938C21.2983 0.175437 20.7641 0.175437 20.4346 0.504938L9.18466 11.755L8.65625 13.4766L10.3778 12.9481L21.6278 1.69818ZM4.15625 1.38281C2.13695 1.38281 0.5 3.01977 0.5 5.03906V17.9766C0.5 19.9958 2.13695 21.6328 4.15625 21.6328H17.0938C19.113 21.6328 20.75 19.9958 20.75 17.9766V8.97656C20.75 8.51057 20.3722 8.13281 19.9062 8.13281C19.4403 8.13281 19.0625 8.51057 19.0625 8.97656V17.9766C19.0625 19.0639 18.1811 19.9453 17.0938 19.9453H4.15625C3.06894 19.9453 2.1875 19.0639 2.1875 17.9766V5.03906C2.1875 3.95175 3.06894 3.07031 4.15625 3.07031H13.1562C13.6222 3.07031 14 2.69255 14 2.22656C14 1.76057 13.6222 1.38281 13.1562 1.38281H4.15625Z" fill="currentColor"/>
          </svg>
        </button>
        <button :class="{'opacity-70': isLoading}" :disabled="isLoading" type="button" @click="remove">
          <svg class="cursor-pointer transition-colors hover:text-[hsl(var(--roke-text-blue))]" fill="none" height="24" viewBox="0 0 23 24" width="23" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.25195 4.625H13.752C13.752 3.38236 12.7446 2.375 11.502 2.375C10.2593 2.375 9.25195 3.38236 9.25195 4.625ZM7.56445 4.625C7.56445 2.45038 9.32733 0.6875 11.502 0.6875C13.6766 0.6875 15.4395 2.45038 15.4395 4.625H21.9082C22.3742 4.625 22.752 5.00276 22.752 5.46875C22.752 5.93474 22.3742 6.3125 21.9082 6.3125H20.4242L19.1057 19.9376C18.8965 22.1001 17.0791 23.75 14.9065 23.75H8.09735C5.92481 23.75 4.1075 22.1001 3.89822 19.9376L2.57967 6.3125H1.0957C0.629717 6.3125 0.251953 5.93474 0.251953 5.46875C0.251953 5.00276 0.629717 4.625 1.0957 4.625H7.56445ZM9.81445 9.96875C9.81445 9.50276 9.43668 9.125 8.9707 9.125C8.50472 9.125 8.12695 9.50276 8.12695 9.96875V18.4062C8.12695 18.8722 8.50472 19.25 8.9707 19.25C9.43668 19.25 9.81445 18.8722 9.81445 18.4062V9.96875ZM14.0332 9.125C14.4992 9.125 14.877 9.50276 14.877 9.96875V18.4062C14.877 18.8722 14.4992 19.25 14.0332 19.25C13.5672 19.25 13.1895 18.8722 13.1895 18.4062V9.96875C13.1895 9.50276 13.5672 9.125 14.0332 9.125ZM5.57788 19.775C5.70344 21.0725 6.79383 22.0625 8.09735 22.0625H14.9065C16.2101 22.0625 17.3004 21.0725 17.426 19.775L18.7288 6.3125H4.27504L5.57788 19.775Z" fill="currentColor"/>
          </svg>
        </button>
      </div>
    </div>
    <div class="flex flex-col">
      <span>Компания: {{ props.requisite.organizationFullName }}</span>
      <span>ИНН: {{ props.requisite.inn }}</span>
    </div>
  </div>
</template>